export const ExchangeRateLifetime = 1000 * 60
